import { render, staticRenderFns } from "./View404.vue?vue&type=template&id=4b3dff82"
import script from "./View404.vue?vue&type=script&lang=js"
export * from "./View404.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports